import { Node, mergeAttributes, VueNodeViewRenderer } from '@tiptap/vue-3'
import EditorCondition from '../EditorCondition.vue'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    condition: {
      /**
       * Add a condition based on a template variable
       */
      addCondition: (_code: string) => ReturnType
      /**
       * Remove a condition
       */
      removeCondition: () => ReturnType
    }
  }
}

export interface ConditionOptions {
  HTMLAttributes: Record<string, unknown>
}

export const ExtensionCondition = Node.create<ConditionOptions>({
  name: 'condition',
  content: 'block*',
  group: 'block',
  atom: true,
  addOptions() {
    return {
      HTMLAttributes: { class: 'condition' },
    }
  },
  addAttributes() {
    return {
      code: {
        default: null,
        renderHTML: attributes => {
          return {
            'data-condition-code': attributes.code,
          }
        },
        parseHTML: element => element.getAttribute('data-condition-code'),
      },
    }
  },
  renderHTML({ HTMLAttributes }) {
    return ['editor-condition', mergeAttributes(HTMLAttributes, this.options.HTMLAttributes), 0]
  },
  addCommands() {
    return {
      addCondition:
        (code: string) =>
        ({ commands }) => {
          return commands.wrapIn(this.name, { code })
        },
      removeCondition:
        () =>
        ({ commands }) => {
          return commands.lift(this.name)
        },
    }
  },
  addNodeView() {
    return VueNodeViewRenderer(EditorCondition)
  },
})
export default ExtensionCondition
